import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import {
    getFirestore, doc, setDoc, query, where, getDocs, getDoc,
    collection, updateDoc, increment, decrement, addDoc
} from "firebase/firestore";
import CryptoJS from "crypto-js";
import { getVideoStatus } from './Script'
import axios from "axios";




const firebaseConfig = {
    apiKey: process.env.REACT_APP_apikey,
    authDomain: process.env.REACT_APP_authDomain,
    projectId: process.env.REACT_APP_projectId,
    storageBucket: process.env.REACT_APP_storageBucket,
    messagingSenderId: process.env.REACT_APP_messagingSenderId,
    appId: process.env.REACT_APP_appId
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const secretKey = "MobYhEGrLSyDxbox";
const ivString = "moBQZcTleSVNIbOx";

const now = new Date();
const formattedDate = now.toISOString().slice(0, 10); // Format as 'YYYY-MM-DD'

// export async function MobiSignin(Phonenumber, Password, Country) {
//     axios.get(`https://apiv2.mobileartsme.com/login?serviceid=8&phonenumber=${Phonenumber}&password=${Password}&type=signin&country=${Country}`)
//         .then(response => {
//             console.log(response.data)
//             if (response.data.Error === 0 || response.Result.Status === 0 ) {
//                 checkPhoneNumberAndCreateUser(Phonenumber)
//             } 
//         })
// }


// export async function decodeJWTAndDecryptSub(token) {
//     // Split the token into parts (header, payload, signature)
//     const parts = token.split('.');


//     if (parts.length !== 3) {
//         console.log('Invalid token format, checking if it’s a phone number');

//         const trimmedToken = token.trim(); // Remove leading and trailing spaces

//         if (/^\+?\d+$/.test(trimmedToken)) {
//             console.log('Token is a valid phone number:', trimmedToken);
//             MobiSignin()
//             return true;
//         } else {
//             console.log('Token is neither a valid phone number nor a valid JWT.');
//             return false;
//         }
//     }



//     const payloadBase64 = parts[1];
//     const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
//     const decodedPayload = atob(base64);
//     // console.log('Decoded JWT Payload:', decodedPayload);
//     const decodedObj = JSON.parse(decodedPayload);

//     const sub = decodedObj.sub;
//     // console.log('Extracted sub field:', sub);

//     if (!sub) {
//         // console.log('No "sub" field found in the payload');
//         return;
//     }

//     // Check if the 'sub' field is in HEX (or needs to be decrypted)
//     if (isHex(sub)) {
//         console.log('Sub field is in HEX format. Decrypting...');
//         const decryptedSub = decryptAES(sub, secretKey, ivString);

//         // Find the index of the '/' and slice the string if it exists
//         const phonenumbIndex = decryptedSub.indexOf('/');
//         let phonenumb = phonenumbIndex !== -1 ? decryptedSub.slice(0, phonenumbIndex) : decryptedSub;

//         phonenumb = phonenumb.replace(/[^\d]/g, '');

//         console.log('Phone number extracted:', phonenumb);

//         if (phonenumb) {
//             await checkPhoneNumberAndCreateUser(phonenumb);
//         }
//     } else {
//         console.log('Sub field is not in HEX format. It might be plain text.');
//     }

// }



export async function MobiSignin(Phonenumber, Password, Country) {
    try {
        const response = await axios.get(
            `https://apiv2.mobileartsme.com/login?serviceid=8&phonenumber=${Phonenumber}&password=${Password}&type=signin&country=${Country}`
        );

        console.log(response.data);

        if (response.data.Error === 0 || response.data.Result?.Status === 0) {
            await checkPhoneNumberAndCreateUser(Phonenumber);
        }

        return response.data;
    } catch (error) {
        console.error("MobiSignin failed:", error);
        return null;
    }
}

export async function decodeJWTAndDecryptSub(token) {
    const trimmedToken = token.trim();
    const parts = trimmedToken.split('.');

    // **Condition 1: Check if it's a JWT**
    if (parts.length === 3) {
        console.log("Valid JWT detected. Decoding...");

        const payloadBase64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const decodedPayload = atob(payloadBase64);
        const decodedObj = JSON.parse(decodedPayload);
        const sub = decodedObj.sub;

        if (!sub) {
            console.log('No "sub" field found in the payload');
            return false;
        }

        // **Check if 'sub' is in HEX format and decrypt**
        if (isHex(sub)) {
            console.log('Sub field is in HEX format. Decrypting...');
            const decryptedSub = decryptAES(sub, secretKey, ivString);

            const phonenumbIndex = decryptedSub.indexOf('/');
            let phonenumb = phonenumbIndex !== -1 ? decryptedSub.slice(0, phonenumbIndex) : decryptedSub;

            phonenumb = phonenumb.replace(/[^\d]/g, '');
            console.log('Phone number extracted:', phonenumb);

            if (phonenumb) {
                await checkPhoneNumberAndCreateUser(phonenumb);
            }
        } else {
            console.log('Sub field is not in HEX format. It might be plain text.');
        }

        return true;
    }

    // **Condition 2: Check if it's a valid phone number**
    if (/^\+?\d+$/.test(trimmedToken)) {
        console.log('Token is a valid phone number:', trimmedToken);
        await MobiSignin(trimmedToken, null, null); // Password and Country are unknown
        return true;
    }

    // **Condition 3: Check if it's a query string with parameters**
    console.log('Invalid JWT format. Checking if it contains login parameters...');
    const params = new URLSearchParams(trimmedToken);

    const Phonenumber = params.get("phonenumber");
    const Password = params.get("password");
    const Country = params.get("country");
    const ServiceId = params.get("serviceid");
    const Type = params.get("type");

    if (Phonenumber && Password && Country && ServiceId === "8" && Type === "signin") {
        console.log("Detected query parameters for login. Calling MobiSignin...");
        return await MobiSignin(Phonenumber, Password, Country);
    }

    // **No valid condition met**
    console.log("Token is neither a valid JWT, phone number, nor a valid query parameter string.");
    return false;
}


function isHex(str) {
    return /^[0-9A-Fa-f]+$/.test(str);
}

function decryptAES(encryptedHex, secretKey, ivString) {
    try {
        if (secretKey.length !== 16 || ivString.length !== 16) {
            throw new Error('Key and IV must be 16 characters (16 bytes) long.');
        }

        // Convert the encrypted HEX string to a WordArray
        const encryptedWords = CryptoJS.enc.Hex.parse(encryptedHex);

        // Create the key and IV using CryptoJS
        const key = CryptoJS.enc.Utf8.parse(secretKey);
        const iv = CryptoJS.enc.Utf8.parse(ivString);

        // Decrypt the data using AES (CBC mode) and try different padding strategies
        const decrypted = CryptoJS.AES.decrypt({ ciphertext: encryptedWords }, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC, // Switching to CBC mode
            padding: CryptoJS.pad.Pkcs7 // Trying PKCS7 padding
        });

        // Attempt to return the decrypted string as UTF-8
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

        if (!decryptedText) {
            console.error('Decryption returned an empty string or invalid UTF-8 data.');
            return null;
        }

        return decryptedText;
    } catch (e) {
        console.error('Decryption failed:', e);
        return null;
    }
}

export async function checkPhoneNumberAndCreateUser(decryptedSub) {
    try {

        const userRef = collection(db, 'users');

        const q = query(userRef, where("phoneNumber", "==", decryptedSub));

        const querySnapshot = await getDocs(q);


        if (!querySnapshot.empty) {

            const userDoc = querySnapshot.docs[0]; // Get the first matching document
            const userData = userDoc.data();

            console.log('Phone number exists. Returning UUID:', userData.uuid);

            // Save user data in sessionStorage for future use
            sessionStorage.setItem(
                "AI_UserData",
                JSON.stringify({
                    uuid: userData.uuid,
                    phone: userData.phoneNumber,
                    date: userData.date,
                    talking_photo_limit: userData.talking_photo_limit,
                    avatar_limit: userData.avatar_limit,
                    streaming_limit: userData.streaming_limit,
                    upload_limit: userData.upload_limit,
                    image_generation_limit: userData.image_generation_limit
                })
            );

            await UpdateAnalytics('logins')

            return userData.uuid; // Return the UUID of the found user
        } else {
            // User not found, create a new user
            console.log('Phone number not found. Creating a new user...');
            await UpdateAnalytics('logins')
            return await createUserAndStoreData(decryptedSub);
        }
    } catch (error) {
        console.error('Error checking or creating user:', error);
        throw error; // Re-throw the error for further handling, if needed
    }
}


// Function to create an anonymous user and store the data in Firestore
async function createUserAndStoreData(decryptedSub) {
    try {
        // Sign in anonymously to Firebase
        const userCredential = await signInAnonymously(auth);
        const user = userCredential.user;

        const userRef = doc(db, 'users', decryptedSub);

        const userData = {
            phoneNumber: decryptedSub,
            uuid: user.uid,
            date: formattedDate,
            image_generation_limit: 1,
            talking_photo_limit: 51,
            avatar_limit: 51,
            streaming_limit: 51,
            upload_limit: 3
        };

        // Store the data in Firestore
        await setDoc(userRef, userData);
        await UpdateAnalytics('users')
        console.log('User created and data saved:', userData);
        return user; // Return the newly created user UUID
    } catch (error) {
        console.error('Error creating user and storing data:', error);
    }
}


export async function UpdateUserLimits(type, phone, duration) {
    const userRef = doc(db, "users", phone);
    const docSnap = await getDoc(userRef);

    try {
        if (docSnap.exists()) {
            const userData = docSnap.data();

            // For image upload limits
            if (!duration) {
                const uploadLimits = userData.upload_limit;
                const newUploadLimit = uploadLimits - 1;

                await updateDoc(userRef, { [type]: newUploadLimit });

                // Update sessionStorage
                const userDataFromSession = JSON.parse(sessionStorage.getItem("AI_UserData"));
                if (userDataFromSession) {
                    userDataFromSession.upload_limit = newUploadLimit;
                    sessionStorage.setItem("AI_UserData", JSON.stringify(userDataFromSession));
                }
            } else {
                // For other types with a duration
                let updatedLimit = userData[type] - duration;
                if (updatedLimit < 0) {
                    updatedLimit = 0; // Prevent negative limits
                }

                await updateDoc(userRef, { [type]: updatedLimit });

                // Update sessionStorage
                const userDataFromSession = JSON.parse(sessionStorage.getItem("AI_UserData"));
                if (userDataFromSession) {
                    userDataFromSession[type] = updatedLimit;
                    sessionStorage.setItem("AI_UserData", JSON.stringify(userDataFromSession));
                }

                console.log("Limit Updated:", updatedLimit);
            }
        } else {
            console.log("User not found");
        }
    } catch (e) {
        console.error("Error in updating limits:", e);
    }
}



export async function UpdateAnalytics(type) {

    try {
        const analyticsRef = doc(db, "analytics", formattedDate); // Reference to today's analytics document

        // Check if the document exists
        const docSnap = await getDoc(analyticsRef);

        if (docSnap.exists()) {
            // Increment the specified field by 1
            await updateDoc(analyticsRef, {
                [type]: increment(1), // Use Firebase's increment function
            });
            console.log(`Analytics updated: Incremented "${type}" by 1.`);
        } else {
            const initialData = {
                [type]: 1, // Initialize the field with 1
            };

            await setDoc(analyticsRef, initialData);
            console.log("Analytics document created:", initialData);
        }
    } catch (e) {
        console.error("Error in updating analytics:", e);
    }
}



export async function AddVideo(category, video_id, title) {
    const uuid = JSON.parse(sessionStorage.getItem('AI_UserData')).uuid;
    const phonenumber = JSON.parse(sessionStorage.getItem('AI_UserData')).phone;

    try {
        const userRef = doc(db, category, uuid);  // Reference to user's document
        const docSnap = await getDoc(userRef);   // Retrieve the document

        let data;

        if (docSnap.exists()) {
            const existingData = docSnap.data();

            const updatedData = existingData || {};

            updatedData[video_id] = { title: title };

            data = updatedData;
        } else {
            data = {
                [video_id]: {
                    title: title,
                }
            };
        }

        await setDoc(userRef, data, { merge: true });

        if (category === 'streaming') {
            UpdateUserLimits("streaming_limit", phonenumber, 3)
        }
        if (category === 'avatar') {
            UpdateUserLimits("avatar_limit", phonenumber, 3)
        }
        if (category === 'talking_photo') {
            UpdateUserLimits("talking_photo_limit", phonenumber, 3)
        }

        console.log('Video added', data);

        return "Your Video is being generated";
    } catch (error) {
        console.error('Error adding video and storing data:', error);
        return "Error Generating Video";
    }
}



export async function getVideosFirebase(category, uuid) {

    try {
        const userRef = doc(db, category, uuid);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
            const existingData = docSnap.data();

            // Object.entries(existingData).forEach(async ([key, value]) => {
            //     if (value.status) {
            //         console.log(key, "is already completed");
            //     } else {
            //         const statusData = await getVideoStatus(key);
            //         if (statusData.status === "completed") {
            //             // Merge existing value with the new statusData
            //             const updatePayload = {
            //                 [key]: {
            //                     ...value, // Keep the existing value
            //                     ...statusData, // Add/Update with new statusData
            //                 },
            //             };
            //             await updateDoc(userRef, updatePayload);
            //         } else {
            //             console.log(key, "is not completed yet");
            //         }
            //     }
            // });



            // console.log(existingData)
            return existingData;
        } else {
            return []
        }


    } catch (error) {
        console.error('Error adding video and storing data:', error);
        return "Error Generating Video";
    }
}


export async function updateSingleVideoStatus(category, uuid, id) {
    let updatePayload;
    try {
        const userRef = doc(db, category, uuid); // Reference to the document
        const docSnap = await getDoc(userRef); // Fetch the document

        if (docSnap.exists()) {
            const existingData = docSnap.data(); // Get the existing data

            // Check if the specific video exists in the document
            if (existingData[id]) {
                const videoData = existingData[id];

                if (videoData.status === "completed") {
                    console.log(id, "is already completed");
                    return existingData;
                } else {
                    // Fetch the status of the specific video
                    const statusData = await getVideoStatus(id);
                    if (statusData.status === "completed") {

                        updatePayload = {
                            [id]: {
                                ...videoData, // Keep the existing value
                                ...statusData, // Add/Update with new status data
                            },
                        };
                        await updateDoc(userRef, updatePayload); // Update only the specific video
                        console.log(id, "has been updated to completed");
                    } else {
                        console.log(id, "is not completed yet");
                        return 0;
                    }
                }
            } else {
                console.log(id, "does not exist in the document");
            }

            return updatePayload;
        } else {
            console.log("Document does not exist");
            return [];
        }
    } catch (error) {
        console.error("Error updating video status:", error);
        return "Error Updating Video";
    }
}

export async function updateExpired(category, uuid, id) {
    let updatePayload;
    try {
        const userRef = doc(db, category, uuid); // Reference to the document
        const docSnap = await getDoc(userRef); // Fetch the document

        if (docSnap.exists()) {
            const existingData = docSnap.data(); // Get the existing data
            if (existingData[id]) {

                const videoData = existingData[id];
                const statusData = await getVideoStatus(id);

                updatePayload = {
                    [id]: {
                        ...videoData, // Keep the existing value
                        ...statusData, // Add/Update with new status data
                    },
                };
                await updateDoc(userRef, updatePayload); // Update only the specific video
                console.log(id, "has been updated to completed");


            } else {
                console.log(id, "does not exist in the document");
            }

            return updatePayload;
        } else {
            console.log("Document does not exist");
            return [];
        }
    } catch (error) {
        console.error("Error updating video status:", error);
        return "Error Updating Video";
    }
}



// Old function
// export async function uploadPhotoFirebase(image) {
//     const uuid = JSON.parse(sessionStorage.getItem('AI_UserData')).uuid;

//     const userRef = doc(db, 'image_uploads', uuid);  // Reference to the user's document

//     try {
//         // Get the user's document
//         const docSnap = await getDoc(userRef);

//         // If the document exists
//         if (docSnap.exists()) {
//             // Retrieve the current data
//             const existingData = docSnap.data();
//             const updatedImages = [...existingData.images, image]; // Append the new image to the images array

//             // Update the document with the new images array
//             await setDoc(userRef, { images: updatedImages }, { merge: true });

//             console.log('Image uploaded successfully');
//             return 'Image uploaded successfully';
//         } else {
//             // If the document doesn't exist, create it with the image array
//             await setDoc(userRef, { images: [image] });

//             console.log('New user document created and image uploaded');
//             return 'New user document created and image uploaded';
//         }
//     } catch (error) {
//         console.error('Error uploading image:', error);
//         return 'Error uploading image';
//     }
// }

// New function
export async function uploadPhotoFirebase(data) {
    const uuid = JSON.parse(sessionStorage.getItem('AI_UserData')).uuid;
    const userRef = doc(db, 'image_uploads', uuid);  // Reference to the user's document in Firestore


    try {
        const docSnap = await getDoc(userRef); // Check if the document exists
        const newImage = {
            id: data.talking_photo_id,          // Use the id from the data object
            image_url: data.talking_photo_url // Use the image_url from the data object
        };

        if (docSnap.exists()) {
            const existingData = docSnap.data();  // Get the existing data

            const existingImages = existingData.images || [];

            const updatedImages = [...existingImages, newImage];

            await setDoc(userRef, { images: updatedImages }, { merge: true });
            await UpdateAnalytics('uploads')
            console.log('Image uploaded successfully');

            return 'Image uploaded successfully';

        } else {
            await setDoc(userRef, { images: [newImage] });
            await UpdateAnalytics('uploads')
            console.log('New user document created and image uploaded');
            return 'New user document created and image uploaded';
        }


    } catch (error) {
        console.error('Error uploading image:', error);
        return 'Error uploading image';
    }
}


export async function getUploads() {
    const sessionUploads = JSON.parse(sessionStorage.getItem("AI_Uploads"))
    if (sessionUploads) {
        return sessionUploads
    } else {
        console.log("NO AI UPLOADS")
        const uuid = JSON.parse(sessionStorage.getItem('AI_UserData')).uuid;
        const userRef = doc(db, 'image_uploads', uuid);  // Reference to the user's document
        try {
            const docSnap = await getDoc(userRef);

            if (docSnap.exists()) {
                const existingData = docSnap.data();
                sessionStorage.setItem('AI_Uploads', JSON.stringify(existingData.images))
                return existingData.images;
            } else {
                console.log("no data in image uplaods from firebase")
                return [];
            }
        } catch (error) {
            console.error('Error getting uploads:', error);
            return 'Error getting uploadas';
        }
    }

}


async function cacheFirebase() {
    const userRef = doc(db, 'cache', "avatars");

    try {
        // Get existing data
        const docSnap = await getDoc(userRef);
        let existingData = docSnap.exists() ? docSnap.data() : {};

        // Get cached data from sessionStorage
        const cachedStreaming = JSON.parse(sessionStorage.getItem("AI_Avatars")) || [];

        let updates = {};
        cachedStreaming.forEach((item, index) => {
            // Use a unique key for each item (e.g., item.id, or "stream_" + index)
            let key = `${index}`;
            updates[key] = item;
        });

        // Update Firestore without nesting under 'avatars'
        await updateDoc(userRef, updates);

        console.log("Cache updated successfully!");
    } catch (error) {
        console.error("Error updating Firestore:", error);
    }
}


export async function getCachedData(type) {

    const sessionStorageMap = {
        "avatars": "AI_Avatars",
        "streaming_avatars": "AI_Streaming",
        "talking_photos": "AI_TalkingPhotos",
        "voices": "AI_Voices"
    };

    // Convert type to lowercase and check if it exists in the map
    const sessionStorageKey = sessionStorageMap[type.toLowerCase()];
    console.log("sessionStorageKey : ", sessionStorageKey)
    if (!sessionStorageKey) {
        console.error("Invalid type provided:", type);
        return;
    }

    const userRef = doc(db, "cache", type);

    try {
        const existingSessionData = sessionStorage.getItem(sessionStorageKey);
        if (existingSessionData) {
            console.log(`cached.`);
            const parsedData = JSON.parse(existingSessionData);
            const arr = parsedData ? Object.values(parsedData) : [];
            return arr;
        }


        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
            const data = docSnap.data();

            // Save to session storage
            sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
            console.log('not cached');
            const arr = data ? Object.values(data) : [];
            return arr;
        } else {
            console.warn(`No document found for ${type} in Firestore.`);
        }
    } catch (error) {
        console.error("Error fetching data from Firestore:", error);
    }
}




export async function UpdateExpiredTalkingPhoto() {
    // Get data from sessionStorage and parse it
    const talkingPhotosRaw = sessionStorage.getItem("AI_TalkingPhotos");
    const uploadsRaw = sessionStorage.getItem("AI_Uploads");
    const userDataRaw = sessionStorage.getItem("AI_UserData");

    const talkingphotos = talkingPhotosRaw ? Object.values(JSON.parse(talkingPhotosRaw)) : [];
    const uploads = uploadsRaw ? Object.values(JSON.parse(uploadsRaw)) : [];
    const uuid = userDataRaw ? JSON.parse(userDataRaw).uuid || "" : "";
    

    // Helper function to check expiry status of a given photo list
    const isExpired = (photos) => {
        if (!Array.isArray(photos) || photos.length === 0) return false;
        const expires = getExpiresFromUrl(photos[0]?.image_url);
        return isTimestampValid(expires);
    };

    // Check expiry status for both talkingphotos and uploads

    const expiredTalkingPhotos = isExpired(talkingphotos);
    const expiredUploads = isExpired(uploads);

    // Exit early if neither is expired
    if (!expiredTalkingPhotos && !expiredUploads) return;

    // Fetch data only once if either is expired
    try {
        const response = await axios.get(`https://api.heygen.com/v1/talking_photo.list`, {
            headers: {
                "x-api-key": process.env.REACT_APP_X_KEY,
            },
        });
        const heygentalkingphotos = response.data.data;

        // Helper function to update sessionStorage
        const updateSessionStorage = (key, oldPhotos) => {
            if (!Array.isArray(oldPhotos) || oldPhotos.length === 0) return;
            const photoIds = new Set(oldPhotos.map(photo => photo.id));
            const updatedPhotos = heygentalkingphotos.filter(photo => photoIds.has(photo.id));

            if (updatedPhotos.length > 0) {
                sessionStorage.setItem(key, JSON.stringify(updatedPhotos));
                console.log(`${key} successfully updated`);
                return updatedPhotos;
            } else {
                console.log(`No updates were made to ${key}`);
                return [];
            }
        };

        // Update sessionStorage if the data has expired
        let updatedTalkingPhotos = [];
        if (expiredTalkingPhotos) updatedTalkingPhotos = updateSessionStorage("AI_TalkingPhotos", talkingphotos);

        let updatedUploads = [];
        if (expiredUploads) updatedUploads = updateSessionStorage("AI_Uploads", uploads);

        // Add updated values to Firebase if data is updated
        if (updatedTalkingPhotos.length > 0) {
            try {
                const talkingPhotosObject = updatedTalkingPhotos.reduce((obj, item, index) => {
                    obj[`${index}`] = item; // You can customize the key name here (e.g., photo_0, photo_1, etc.)
                    return obj;
                }, {});

                const docRef = doc(db, "cache", "talking_photos"); // Specify document name
                await setDoc(docRef, talkingPhotosObject);

                console.log(`Data successfully updated to document talking_photos`);
            } catch (e) {
                console.error("Error adding document to Firebase:", e);
            }
        }

        if (updatedUploads.length > 0) {
            try {
                const docRef = doc(db, "image_uploads", uuid); // Specify document name
                await setDoc(docRef, { images: updatedUploads });

                console.log(`Data successfully Updated to document image_uploads`);
            } catch (e) {
                console.error("Error adding document to Firebase:", e);
            }
        }

    } catch (error) {
        console.error("Error fetching talking photos:", error);
    }
}


// const addDataToFirebase = async (collectionName, documentName, data) => {
//     try {
//         // Create a reference to the document in Firestore
//         const docRef = doc(db, collectionName, documentName); // Specify document name
//         await setDoc(docRef, data);

//         console.log(`Data successfully added to document '${documentName}' in collection '${collectionName}'`);
//     } catch (e) {
//         console.error("Error adding document to Firebase:", e);
//     }
// };







function isTimestampValid(expires) {
    const expiryDate = new Date(expires * 1000); // Convert to milliseconds
    const now = new Date();
    console.log(expiryDate)

    return expiryDate > now ? !expiryDate.toISOString() : true;
}

function getExpiresFromUrl(url) {
    const params = new URL(url).searchParams;
    const expires = params.get("Expires");
    return expires ? parseInt(expires, 10) : null;
}


// updateVideoStatus("talking_photos", "nknfoSJ0k9OMp2C2ID9t1vNjfxe2")


// const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxNWFjMGU3ZjU5MmZlNTEzZTRhOWQ0ZWE5ZTk0OGFmYSIsImlwYWRkcmVzcyI6IjExNC4xMC4yMC4yNTAiLCJ1c2VyX3R5cGUiOiJpbTMiLCJkZXZpY2VfaWQiOiI3OTQ1YmZlOTRiMGVhZWViIiwiY3VzdGlkIjoiYjhkNjA5YWQyZjExODkzMGU3MzdiZGRkNmE4MDIyY2UiLCJwcm9maWxlcyI6IiIsImxhbmd1YWdlIjoiSUQiLCJzdWJzdHlwZSI6IjliN2EyMTgxODQ5ZTI5YTYxMjlhOGFhZmRkYTE5YzM1IiwiZXhwIjoxNzM2NDgzNDk1LCJpYXQiOjE3MzY0ODI4OTUsInZlcnNpb24iOiI4Mi41LjAifQ.btgp9j5tv3kie2AjvkgwEw-jZDHDTs3v20hM1oB2DfQ';
// decodeJWTAndDecryptSub(token);